import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DriveService from "../../services/DriveService";
import { useState} from "react";
import useNotification from "../../hooks/useNotification";
import {Avatar, IconButton, Tooltip} from "@mui/material";
import {CreateNewFolder} from "@mui/icons-material";
import useDrive from "../../hooks/useDrive";
import AppUiDialogTitle from "../AppUiComponents/AppUiDialogTitle";
import {styled} from "@mui/material/styles";
import {DRIVE_TYPES} from "../../config/appConst";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiPaper-root': {
        minWidth: "40vw"
    }
}));

export default function CreateNewFolderForm({parent}) {
    const {addNotification} = useNotification();
    const {changeCurrentDrive, CurrentDrive} = useDrive();
    const [open, setOpen] = useState(false);
    const [fileName, setFileName] = useState("");
    const toggleClose = () => {
        setOpen(!open)
    };

    const onChangeHandler = e => {
        setFileName(e.target.value)
    }
    const handleSubmit = async () => {

        if (fileName) {
            const { driveType } =  CurrentDrive;
            const path = parent && parent !== "" && parent !== "/" ? parent + "/" + fileName : fileName;
            await DriveService.createFolder({folder: path}, driveType);
            setFileName("");
            const drive = await DriveService.getFileTree(parent, driveType);
            if (driveType === DRIVE_TYPES.SHARED) {
                changeCurrentDrive({parent: parent, drive: {}, sharedDrive: drive, driveType})
            } else {
                changeCurrentDrive({parent: parent, drive, sharedDrive: {}, driveType})
            }
            addNotification({
                type: "success",
                message: "New folder created successfully"
            });
            toggleClose();
        }
    };

    return (
        <div>
            {/* <Avatar variant={"rounded"} style={{width: "45px", height: "45px", backgroundColor: blue[400]}} */}
            <Avatar variant={"rounded"} style={{width: "45px", height: "45px", backgroundColor: "#8c3b61"}}
            
                    onClick={toggleClose}>
                <Tooltip title="Create folder">

                    <IconButton style={{color: "#fff"}}>
                        <CreateNewFolder/>
                    </IconButton>
                </Tooltip>
                </Avatar>
                <BootstrapDialog open={open} onClose={toggleClose} onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <AppUiDialogTitle id="file-exist-dialog-title" onClose={toggleClose}>Create New Folder</AppUiDialogTitle>

                    <DialogContent>
                        <TextField
                            onChange={onChangeHandler}
                            value={fileName}
                            size={"small"}
                            autoFocus
                            margin="dense"
                            name="folderName"
                            label="New Folder Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            InputProps={{disableUnderline: true}}
                            sx={{
                                "& .MuiInputLabel-root": {color: "#8c3b61"},
                                "& .MuiOutlinedInput-root": {
                                  "& > fieldset": { borderColor: "#8c3b61" },
                                },
                              }}

                        />
                    </DialogContent>
                    <DialogActions>
                        <Button style={{backgroundColor: "#8c3b61"}}  size={"small"} variant="contained"
                                onClick={toggleClose} color={"info"}>Cancel</Button>
                        <Button style={{backgroundColor: "#8c3b61"}}  size={"small"} variant="contained" onClick={handleSubmit}>Create</Button>
                    </DialogActions>
                </BootstrapDialog>
        </div>
    );
}
